import { ApiSessions, TimeLimitedSessions } from "accounts"
import { VisitorIdentity } from "cookiesConsent/domain/VisitorIdentity"
import { analyticsForThisPage } from "cookiesConsent/infrastructure/segment/analyticsForThisPage"

const sessionTimeLimitMs = 3000

let pageVisitorIdentity: VisitorIdentity | undefined

export const visitorIdentityForThisPage = (): VisitorIdentity => {
  pageVisitorIdentity =
    pageVisitorIdentity ??
    new VisitorIdentity(
      analyticsForThisPage(),
      new TimeLimitedSessions(new ApiSessions(), sessionTimeLimitMs)
    )
  return pageVisitorIdentity
}
